<template>
	<div class="login">
		<NavBar :loginPage="true" />
		<v-main>
			<LoginForm :afterRegistration="afterRegistration" :provider="provider" />
		</v-main>
		<Footer />
	</div>
</template>

<script>
import NavBar from "@/components/authentication/NavBar.vue";
import Footer from "@/components/authentication/Footer.vue";
import LoginForm from "@/components/authentication/LoginForm.vue";

export default {
	name: "login",
	props: {
		afterRegistration: {
			default: false
		},
		provider: {
			default: false
		}
	},
	components: {
		NavBar,
		Footer,
		LoginForm
	}
};
</script>

<style scoped>
/*STICKY FOOTER*/
.login {
	display: flex;
	min-height: 100vh;
	flex-direction: column;
}
</style>